import classes from './resource-rewards.module.css';

import type { ResourceReward } from '../model/resource-reward';

export const ResourceRewards = ({ rewards }: { rewards: ResourceReward }) => {
  if (
    ![rewards.lives, rewards.inventory?.fiftyFifty, rewards.inventory?.freeze, rewards.inventory?.swapFrame].some(
      (amount) => amount && amount > 0,
    )
  )
    return null;
  return (
    <span className={classes.root}>
      {[
        { amount: rewards.lives, image: '/life-v2.webp', label: 'Жизни' },
        { amount: rewards.inventory?.fiftyFifty, image: '/hint-fifty-fifty.webp', label: '50/50' },
        { amount: rewards.inventory?.freeze, image: '/hint-freeze.webp', label: 'Заморозка' },
        { amount: rewards.inventory?.swapFrame, image: '/hint-extra-frame.webp', label: 'Другой кадр' },
      ]
        .filter(({ amount }) => amount && amount > 0)
        .map(({ amount, image, label }) => (
          <span key={label} aria-label={`${label}: +${amount}`} title={label}>
            <img src={image} alt="" /> <strong>+{amount}</strong>
          </span>
        ))}
    </span>
  );
};
